var render, staticRenderFns
import script from "./Signout.vue?vue&type=script&lang=js"
export * from "./Signout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41337b6",
  null
  
)

export default component.exports